import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  IAuction,
  IBook,
  IDocumentBookCode,
  IUpdateDocumentBookCodeResult,
} from '.';
import { IDictionary } from '../components/DropDownList/DropDownList';
import { BidClient } from '../core/clients';
import { axiosToObservable } from '../core/clients/axiosToObservable';

export class BookService {
  getAllBooks = (): Observable<IBook[]> => {
    return axiosToObservable(BidClient.get<IBook[]>('book/all/books')).pipe(
      map((books: IBook[]) => {
        return books;
      })
    );
  };

  getBooksFromAuction = (auction: IAuction) => {
    let dictionary: IDictionary[] = [];
    let books = auction?.books?.map((x) => {
      return {
        key: x.code,
        value: x.name,
      } as IDictionary;
    });
    return books ? books : dictionary;
  };

  getBookAndDocIdByDocId = (docId: string): Observable<IDocumentBookCode> => {
    return axiosToObservable(BidClient.get<IDocumentBookCode>(`book/bookAndDocIdByDocId/${docId}`)).pipe(
      map((documentBookCode: IDocumentBookCode) => {
        return documentBookCode;
      })
    );
  };

  associateBookWithDocId = (
    documentBookCode: IDocumentBookCode
  ): Observable<IUpdateDocumentBookCodeResult> => {
    return axiosToObservable(BidClient.post<IUpdateDocumentBookCodeResult>('book/associateBookWithDocId', documentBookCode)).pipe(
      map((updateDocumentBookCodeResult: IUpdateDocumentBookCodeResult) => {
        return updateDocumentBookCodeResult;
      })
    );
  };
}
